var inherit = require("../../general.js").inherit;
var ObservableShadow = require("./../observableShadow.js");

var ObservableTreeShadow = function(treeNode, name, getter, setter, sensitivityList){
    ObservableShadow.call(this, getter, setter, sensitivityList, treeNode);
    this._treeNode = treeNode;
    this._name = name;
};
inherit(ObservableTreeShadow, ObservableShadow);
ObservableTreeShadow.createNewFunction = ObservableShadow.createNewFunction;
ObservableTreeShadow.prototype.getName = function(){ return this._name; };
ObservableTreeShadow.prototype.getTreeNode = function(){ return this._treeNode; };

ObservableTreeShadow.prototype.setDirty = function(trigger){
    ObservableShadow.prototype.setDirty.call(this);

    var triggerNode = trigger._treeNode || trigger; // node who triggered this setDirty
    if (!triggerNode._triggeredShadows) triggerNode._triggeredShadows = [];
    triggerNode._triggeredShadows.push(this);

};

module.exports = ObservableTreeShadow;